/* eslint-disable prefer-template */
/**
 * IE doesn't support classList on DOM nodes so we need to manually handle it
 * Ported from toddmotto/lunar into the app to reduce risk of depending on
 * an unmaintained package relative to the size of the package.
 */
function hasClass(elem, name) {
    return new RegExp('(\\s|^)' + name + '(\\s|$)').test(elem.getAttribute('class'));
}

function addClass(elem, name) {
    !hasClass(elem, name) && elem.setAttribute('class',
        (elem.getAttribute('class') ? elem.getAttribute('class') + ' ' : '') + name);
}

function removeClass(elem, name) {
    if (hasClass(elem, name)) {
        const remove = elem.getAttribute('class').replace(new RegExp('(\\s|^)' + name + '(\\s|$)', 'g'), '$2');
        elem.setAttribute('class', remove);
    }
}

export default {
    hasClass,
    addClass,
    removeClass
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/common/svgClasses.js